import { useState, useCallback } from 'react';
import api from '../services/api';

export function useRedemption() {
  const [loading, setLoading]   = useState(false);
  const [result, setResult]     = useState(null);
  const [error, setError]       = useState(null);

  const redeem = useCallback(async (couponId, orderValue = null) => {
    setLoading(true);
    setError(null);
    setResult(null);
    try {
      const payload = { coupon_id: couponId };
      if (orderValue) payload.order_value = orderValue;
      const { data } = await api.post('/coupons/redeem', payload);
      setResult(data);

      // Track the redemption event
      api.post('/track', { coupon_id: couponId, event_type: 'copy_code' }).catch(() => {});

      return { success: true, data };
    } catch (err) {
      const msg = err.response?.data?.error || 'Redemption failed';
      setError(msg);
      return { success: false, error: msg };
    } finally { setLoading(false); }
  }, []);

  const trackClick = useCallback((couponId, sessionId) => {
    api.post('/track', { coupon_id: couponId, event_type: 'click', session_id: sessionId }).catch(() => {});
  }, []);

  const trackImpression = useCallback((couponId, sessionId) => {
    api.post('/track', { coupon_id: couponId, event_type: 'impression', session_id: sessionId }).catch(() => {});
  }, []);

  const reset = useCallback(() => { setResult(null); setError(null); }, []);

  return { redeem, trackClick, trackImpression, loading, result, error, reset };
}
